module.exports = __webpack_public_path__ + "img/footer_service.52a642c0.png";